<template>
  <div></div>
</template>

<script>
export default {
    props: ['areaId', 'coords']

}
</script>

<style lang="scss">
 
</style>